<template>
  <span>
    <v-dialog v-model="show" max-width="800" persistent>
      <v-card height="600px">
        <v-card-title class="headline">          
            <span class="text-h6">🎉 Official Launch Announcement!</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="Close()" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4" style="font-size: 18px;">
          <p>
            We're thrilled to announce that <strong>Ragnamex Hardcore</strong> will officially launch on <strong>May 30th</strong>!
          </p>
          <p class="mt-4">
            For updates, open beta details, and tons of exciting content, make sure to join our
            <a href="https://discord.gg/ppMyV4e" target="_blank" style="color: #7289da; text-decoration: none;">
              Discord server
            </a>.
          </p>
          <p class="mt-4">
            Stay connected and be part of the journey!
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </span>
</template>
<script>
export default {
    props:[
      'show',
    ],
    data: () => ({
    }),
    methods: {
      Close(){
        this.$emit('close');
      },

    },
}
</script>